import React from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import requireAuth from '../../components/hocs/requireAuth';
import requireOnboarding from '../../components/hocs/requireOnboarding';
import requirePremiumMembership from '../../components/hocs/requirePremiumMembership';
import * as actions from '../../actions/manage-list-actions';
import CheckBox from '../../components/ManageSavedLists/CheckBox';
import ListDropDown from '../../components/SaveToList/ListDropDown';
import { savedListTypes, getPlayerName } from '../../utils';

import styles from './manageSavedLists.scss';

class ManageSavedLists extends React.Component {
    constructor(props) {
        super(props);
        const parsed = queryString.parse(this.props.location.search);

        const createDisplayName = (location, listType) => {
            if (location && listType && location.state) {
                const savedItem = location.state;
                if (listType === savedListTypes.players.key) {
                    return getPlayerName(savedItem.firstName, savedItem.lastName);
                }
                if (listType === savedListTypes.schools.key) {
                    return savedItem.name;
                }
                return 'Manage Lists';
            }
            return 'Manage Lists';
        };

        this.state = {
            showCreateList: false,
            redirect: false,
            redirectUrl: parsed.next || '/saved/players',
            displayName: createDisplayName(this.props.location, this.props.match.params.listType),
        };
        this.closeListsDropDown = this.closeListsDropDown.bind(this);
        this.openCreateListForm = this.openCreateListForm.bind(this);
        this.handleCreateList = this.handleCreateList.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidMount() {
        if (savedListTypes.players.key !== this.props.match.params.listType && savedListTypes.schools.key !== this.props.match.params.listType) {
            this.saveData(false);
        } else {
            this.props.saveRecievedDetails(this.props.match.params.listType, this.props.match.params.id);
        }
    }

    closeListsDropDown() {
        this.setState({
            showCreateList: false,
            createListError: false,
        });
    }

    openCreateListForm() {
        this.setState({
            showCreateList: true,
        });
    }

    async handleCreateList(values) {
        try {
            if (!values.listName) {
                this.setState({
                    createListError: 'Please enter a name to create list',
                });
            } else {
                await this.props.createList(values.listName);
                this.closeListsDropDown();
            }
        } catch (err) {
            this.setState({
                createListError: err.message === 'exists' ? 'You must select a unique list name' : 'Error creating list!',
            });
        }
    }

    async saveData(save) {
        try {
            if (save) {
                await this.props.saveData();
            }
            this.setState({
                redirect: true,
            });
        } catch (err) {
            console.log('SaveData error', err);
        }
    }

    render() {
        const {
            createListError,
        } = this.state;

        if (this.state.redirect) {
            window.location.href = this.state.redirectUrl;
        }
        return (
            <div className={`${styles.saveToList}`}>
                <div className={`container`}>
                    <div className={`text-callout ${styles.title}`} data-testid="manage-saved-lists.page.title">
                        {this.state.displayName}
                    </div>
                    <div className={`d-flex flex-row align-items-end ${styles.buttonContainer}`}>
                        <ListDropDown
                            handleCreateList={this.handleCreateList}
                            closeListsDropDown={this.closeListsDropDown}
                            openCreateListForm={this.openCreateListForm}
                            showCreateList={this.state.showCreateList}
                            listCreationFailed={this.props.listCreationfailed}
                            errorMessage={this.props.errorMessage || createListError}
                            creatingListName={this.props.creatingListName}
                            listFor="manageList"
                        />
                        <div className={`${styles.dummyView}`} />
                        <button
                            type="button"
                            className={`btn btn-primary btn-sm text-uppercase ${styles.button} ${styles.remove}`}
                            onClick={() => {
                                this.saveData(false);
                            }}
                            data-testid="manage-saved-lists.page.cancel-btn"
                        >
                            CANCEL
                        </button>
                        <button
                            type="button"
                            className={`btn btn-primary btn-sm text-uppercase ${styles.button}`}
                            onClick={() => {
                                this.saveData(true);
                            }}
                            data-testid="manage-saved-lists.page.save-btn"
                        >
                            SAVE
                        </button>
                    </div>
                    <div className={`${styles.rowContainer}`}>
                        <div className={`row`}>
                            {this.props.savedLists.map((savedList) => (
                                <div
                                    className={`col-12 col-md-4 ${styles.checkBoxColumn}`}
                                    key={`check-box-${savedList.id}`}
                                >
                                    <CheckBox
                                        item={savedList}
                                        onChanged={this.props.onSelectionChanged}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        saveData: () => {
            dispatch(actions.saveData());
        },
        saveRecievedDetails: (listType, id) => {
            dispatch(actions.addListTypeAndId(listType, id));
        },
        onSelectionChanged: (listItem) => {
            dispatch(actions.onSelectionChanged(listItem));
        },
        createList: (listName) => {
            return dispatch(actions.createSavedList(listName));
        },
    };
}

function mapStateToProps(state) {
    return {
        user: state.auth.user,
        ...state.manageLists,
    };
}

export default requireAuth(requireOnboarding(requirePremiumMembership(connect(mapStateToProps, mapDispatchToProps)(ManageSavedLists))));
